import * as types from './types';
import * as contactTypes from '../types';
import * as bookingPromoterTypes from '../../../booking/store/promoters/types';
import { ContactFilesService } from '../../services/contact_files.service';
import router from '../../../../router';
import { BookingStoreNamespace } from '../../../booking/store';

export const contactFileActions = {
  async [types.ContactFiles.FETCH.ALL]({ commit, getters }, start = 0) {


    // console.log("STORE FILE",contactFiles.data.files)
    if (start > 0) {

      const contactFiles = await ContactFilesService.getContactFilesPage(start);

      console.log("SCROLL", start, contactFiles.data.files, getters.contactFiles);

      commit(types.ContactFiles.SET.ALL, [...(getters.contactFiles || []), ...contactFiles.data.files]);
    }
    else {
      const contactFiles = await ContactFilesService.getContactFiles(start);
      console.log("QQQQQQ", contactFiles)
      commit(types.ContactFiles.SET.ALL, contactFiles.data.files || []);
    }

    commit(types.SET_CONTACT_FILES_LIST_START_ROW, start);
  },
  async [types.ContactFilesSearchResult.FETCH.ALL]({ commit, getters }, searchKey) {
    const searchResult = await ContactFilesService.getContactFilesSearchResult(searchKey);
    commit(types.ContactFilesSearchResult.SET.ALL, searchResult.data.files);
  },
  async [types.ContactFiles.DELETE.SINGLE]({ commit, getters }, item) {
    let itemsAfterDeleted = getters.contactFiles.filter(
      row => row.file_id != item.file_id
    );
    commit(types.ContactFiles.SET.ALL, itemsAfterDeleted);

    let itemsAfterDeletedSR = getters.contactFilesSearchResult.filter(
      row => row.file_id != item.file_id
    );
    commit(types.ContactFilesSearchResult.SET.ALL, itemsAfterDeletedSR);
    const contactFile = await ContactFilesService.deleteContactFile(item.file_id);
  },
  async [types.ContactFiles.SET.ALL]({ commit, dispatch }, { files }) {
    console.log("files",files)
    const { promoter_id, contact_id } = router.currentRoute.params;

    //Update selected booking promoter related files on delete.
    if(promoter_id){
      dispatch(`${BookingStoreNamespace}/${bookingPromoterTypes.PromoterRelatedFiles.SET.ALL}`, {promoter_id, files}, { root: true });
    }

    //Update selected Contact related files on delete/add.
    if(contact_id){
      dispatch(contactTypes.ContactDetails.UPDATE.MULTIPLE, { files });
    }

    commit(types.ContactFiles.SET.ALL, files);
  },

}